   
const constants = {
    USER_KEY: 'userKey'
  };
  export default constants;